/* @ngInject */
function UserFactory($http, $rootScope, Organization) {
  class User {
    constructor(data) {
      if (data) angular.extend(this, data);
    }

    static getTeam(params) {
      return $http
        .get(`${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/team`, { params })
        .then((response) => response.data.map((userData) => new User(userData)));
    }

    static get() {
      return $http.get(`${process.env.SERVER_URL}/api/secure/user`).then((response) => new User(response.data));
    }

    static create(name, surname, email, password, locale) {
      return $http
        .post(`${process.env.SERVER_URL}/api/public/user`, {
          name,
          surname,
          email,
          password,
          locale,
        })
        .then((response) => new User(response.data));
    }

    static resetPassword(email) {
      return $http.post(`${process.env.SERVER_URL}/api/public/user/reset/password`, { email });
    }

    static verifyEmail(verificationEmailToken) {
      return $http.post(`${process.env.SERVER_URL}/api/public/user/verify-email`, { verificationEmailToken });
    }

    static updateDefaultOrganization(defaultOrganizationId) {
      return $http
        .put(`${process.env.SERVER_URL}/api/secure/user/default-organization`, {
          defaultOrganizationId,
        })
        .then((response) => new User(response.data));
    }

    hasOrganization(organizationSlug) {
      if (!this.organizations) return false;

      return this.organizations.some((organization) => organization.slug === organizationSlug);
    }

    getOrganization(organizationSlug) {
      if (!this.organizations) return null;

      for (const organization of this.organizations) {
        if (organization.slug === organizationSlug) {
          return organization instanceof Organization ? organization : new Organization(organization);
        }
      }

      return null;
    }

    getOwnOrganization() {
      if (!this.organizations) return null;

      let ownOrganization = this.organizations.find(
        (organization) => String(organization.owner.id) === String(this.id),
      );
      if (!ownOrganization && this.deletedOrganizations && this.deletedOrganizations.length > 0) {
        ownOrganization = this.deletedOrganizations.find(
          (deletedOrganization) => String(deletedOrganization.owner.id) === String(this.id),
        );
      }
      return ownOrganization;
    }

    isOwner() {
      return Boolean(this.getOwnOrganization());
    }

    hasOrganizations() {
      return this.organizations && this.organizations.length > 0;
    }

    hasPicture() {
      return Boolean(this.profileImg);
    }

    update(data) {
      return $http
        .put(`${process.env.SERVER_URL}/api/secure/user`, data)
        .then((response) => angular.extend(this, response.data));
    }

    updateProfileImage(imgMetadata) {
      return $http
        .post(`${process.env.SERVER_URL}/api/secure/user/picture`, {
          imgMetadata: imgMetadata || null,
        })
        .then((response) => angular.extend(this, response.data));
    }

    resendVerificationEmail() {
      return $http
        .post(`${process.env.SERVER_URL}/api/secure/user/resend-verification-email`)
        .then((response) => angular.extend(this, response.data));
    }
  }

  return User;
}

export default UserFactory;
